"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 4.01c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 .16.05.31.11.44H3.1l4 8h.01c.16.33.49.56.89.56s.72-.23.89-.56h.01l4-8h-.01c.06-.14.11-.28.11-.44z"];
//# sourceMappingURL=symbol-triangle-down.js.map